import { defineStore } from 'pinia'
import { addToCart, getCart, removeFromCart, clearCart } from '../data/pages/cart'
import { CartEvent } from '../pages/cart/types'

export const useCartStore = defineStore('cart', {
  state: () => {
    return {
      items: [] as CartEvent[],
    }
  },

  actions: {
    async getAll(options: {}) {
      const cartEvents = await getCart()
      this.items = cartEvents
    },

    async add(event: CartEvent) {
      const newEvent = await addToCart(event.id || '')
      this.items.push(newEvent)
    },

    async remove(event: CartEvent) {
      const isRemoved = await removeFromCart(event.id || '')

      if (isRemoved) {
        const index = this.items.findIndex(({ id }) => id === event.id)
        this.items.splice(index, 1)
      }
    },

    async clear() {
      const isRemoved = await clearCart()

      if (isRemoved) {
        this.items = []
      }
    },
  },
})
